import React from "react";
import { ToastContainer } from "react-toastify";
import OrderDetails from "../../components/Reports/Order/OrderDetails";

export const ViewOrderDetailPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <OrderDetails />
        </div>
      </div>
    </div>
  );
};
